module.exports = __webpack_public_path__ + "static/media/detail-towel.b6faae6b.png";